import classNames from 'classnames';
import type { FC } from 'react';

import { Accordion, AccordionAppearance } from '@atlas/components';

import Icon from 'components/Icon/Icon';
import { AuthStatus, useClientProfile, useUISettings } from 'store';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import LanguagesSwitcher from './LanguagesSwitcher';
import styles from './Settings.module.scss';
import type { SettingsProps } from './types';

const Settings: FC<SettingsProps> = ({
  appearance = AccordionAppearance.wide,
  onChangeState,
}) => {
  const layout = useLayout();
  const [{ hideBalance }, { setBalanceVisibility }] = useUISettings();
  const [{ status }] = useClientProfile();

  return (
    <Accordion
      appearance={appearance}
      icon={<Icon name="settings.bold" />}
      title={<Translation message="settings" />}
      onChangeState={onChangeState}
      dataId="settings-menu"
    >
      <div className={styles.content}>
        <div
          className={classNames(styles['languages-switcher'], styles[layout])}
        >
          <Icon name="language-exchange" />
          <LanguagesSwitcher />
        </div>
        {status === AuthStatus.signedIn && (
          <label className={styles['hide-balance']}>
            <input
              type="checkbox"
              onChange={({ currentTarget }) =>
                setBalanceVisibility(currentTarget.checked)
              }
              checked={hideBalance}
            />
            <span className={styles.checkmark} />
            <Translation message="hide_balance" />
          </label>
        )}
      </div>
    </Accordion>
  );
};

export default Settings;
